/**
 * Shared text-filter input (v0.34.0, WS-C) — the one filter box every
 * list surface mounts (Home, the inventory port grid, and — WS-G —
 * the remaining pages) so placeholder styling, iconography, and
 * clearing behave identically everywhere.
 *
 * Controlled and presentation-only: the page owns the value and does
 * its own substring filtering.
 */
import { Search } from "lucide-react";

export function FilterBar({
  value,
  onChange,
  placeholder = "Filter…",
  className = "w-80",
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Width / layout overrides — defaults to the Home page's w-80. */
  className?: string;
}) {
  return (
    <div className={["relative", className].join(" ")}>
      <Search className="pointer-events-none absolute left-2 top-2 h-3.5 w-3.5 text-slate-500" />
      <input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded border border-slate-700 bg-slate-900 py-1.5 pl-7 pr-2 text-sm text-slate-100 placeholder:text-slate-500 focus-visible:border-emerald-700 focus-visible:outline-none"
      />
    </div>
  );
}
